import classNames from "classnames";
import React from "react";
import { useDispatch } from "react-redux";
import { setPopupComponent } from "../../store/slices/ui";

function CloseAccount({ show }) {
  const dispatch = useDispatch();
  return (
    <div
      id="popup-close-account"
      className={classNames("popup-container popup-close-account", {
        "show-popup": show,
      })}
    >
      <div className="popup-content">
        <div class="content-scroll-popup">
          <div class="w-full">
            <p>
              Closing your account is permanent and irreversible. All of your
              data will be removed. Are you sure you want to close your account?
            </p>

            <a
              href="#"
              class="btn btn-green"
              onClick={() => dispatch(setPopupComponent(null))}
            >
              Confirm
            </a>
            <a
              href="#"
              class="btn btn-green-brder"
              onClick={() => dispatch(setPopupComponent(null))}
            >
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CloseAccount;
